export default __webpack_public_path__ + "images/BW.c55868b.png";